import { Theme } from '@mui/material'

export const listStyle = ({ theme }: { theme: Theme }) => {
  return {
    margin: 0,
    paddingLeft: '2.3rem',
    color: theme.palette.primary.light,
  }
}
